import React from 'react'
import PropTypes from 'prop-types'
import DangerousInnerHTML from './DangerousInnerHTML'
import { cx } from 'emotion'
import { css } from '@emotion/core'

const styles = css`
  font-size: 13px;
  margin: ${({ isPayments }) => (isPayments ? '10px 32px' : '0px 32px')};
  text-align: justify;
  border-bottom: 1px solid ${({ theme }) => theme.fields.border};
  color: ${({ theme }) => theme.gray.mediumlight};

  @media screen and (max-width: 500px) {
    margin: ${({ isPayments }) => (isPayments ? '10px 16px' : '0px 16px')};
  }
`

const CustomContent = ({ children, className, isLedger, ...rest }) => (
  <DangerousInnerHTML
    {...rest}
    css={styles}
    className={cx(className, 'custom-content')}
    component='div'
    isledger={isLedger?.toString()}
  >
    {children}
  </DangerousInnerHTML>
)

CustomContent.propTypes = {
  /** Content for the component */
  children: PropTypes.any.isRequired,
  //** Any additional styles to be applied  */
  className: PropTypes.string,
  /*accidentally passed it from a parent component, remove it from the DOM element*/
  isLedger: PropTypes.bool,
}

export default CustomContent
